var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallengeDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fd8ea3d6-5fee-4ce3-a152-614d4818daaa",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64,23.62A40.38,40.38,0,1,0,104.39,64,40.42,40.42,0,0,0,64,23.62Zm0,77.76A37.38,37.38,0,1,1,101.39,64,37.42,37.42,0,0,1,64,101.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.35 42.43 64.16 61.62 44.97 42.43 42.85 44.55 62.04 63.74 42.85 82.94 44.97 85.06 64.16 65.86 83.35 85.06 85.47 82.94 66.28 63.74 85.47 44.55 83.35 42.43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeDeclined);
export default __webpack_public_path__ + "static/media/challenge-declined.e5636bc03e179d382dda530c304bb430.svg";
export { ForwardRef as ReactComponent };